(() => {
  if (window.boxzyCartCountReady) return;
  window.boxzyCartCountReady = true;

  const originalFetch = window.fetch;
  let lastCount = null;
  let refreshRunning = false;
  let refreshAgain = false;

  function renderCount(value) {
    const count = Number(value);
    if (!Number.isInteger(count) || count < 0) return;
    const changed = lastCount !== null && count !== lastCount;
    lastCount = count;
    document.querySelectorAll('[data-boxzy-cart-count]').forEach(badge => {
      if (badge.textContent !== String(count)) badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-boxzy-cart-link]').forEach(link => {
      const label = link.dataset.cartLabel.replace('__COUNT__', String(count));
      link.setAttribute('aria-label', label);
      if (changed) {
        const announcement = link.parentElement.querySelector('[data-boxzy-cart-announcement]');
        if (announcement) announcement.textContent = label;
      }
    });
  }

  async function refreshCount() {
    if (refreshRunning) {
      refreshAgain = true;
      return;
    }
    refreshRunning = true;
    do {
      refreshAgain = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await originalFetch.call(window, root + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (response.ok) {
          const cart = await response.json();
          renderCount(cart.item_count);
        }
      } catch {}
    } while (refreshAgain);
    refreshRunning = false;
  }

  function isCartMutation(resource, options) {
    try {
      const request = resource instanceof Request;
      const url = new URL(request ? resource.url : String(resource), window.location.href);
      const method = (options?.method || (request ? resource.method : 'GET')).toUpperCase();
      return method !== 'GET' && url.origin === window.location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  window.fetch = function(resource, options) {
    const result = originalFetch.apply(this, arguments);
    if (isCartMutation(resource, options)) {
      result.then(response => { if (response.ok) refreshCount(); }, () => {});
    }
    return result;
  };

  const countObserver = new MutationObserver(entries => {
    for (const entry of entries) {
      const target = entry.target.nodeType === Node.TEXT_NODE ? entry.target.parentElement : entry.target;
      const source = target.closest?.('.js-cart-count');
      if (source && /^\d+$/.test(source.textContent.trim())) renderCount(source.textContent.trim());
    }
  });

  function observeNativeCounts() {
    countObserver.disconnect();
    document.querySelectorAll('.js-cart-count').forEach(node => countObserver.observe(node, { childList: true, characterData: true, subtree: true }));
  }

  const initialBadge = document.querySelector('[data-boxzy-cart-count]');
  if (initialBadge) renderCount(initialBadge.textContent.trim());
  observeNativeCounts();
  document.addEventListener('boxzy:gift-options-saved', event => renderCount(event.detail?.item_count));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCount(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
  document.addEventListener('shopify:section:load', () => {
    observeNativeCounts();
    refreshCount();
  });
})();
